import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useGetRecognitionOrders = (params = {}, options = {}) => {
  const {
    filters: { recognitionId = '', searchTerm = '', giftStatus = [], type = '', email = '' } = {},
    pagination: { page = 1, limit = 10 } = {}
  } = params;

  return useQuery(
    [
      'recognitionRecipients',
      searchTerm + page + limit + giftStatus + recognitionId + type + email
    ],
    () => {
      return services.orders(
        cleanObjectEmptyFields({
          filters: {
            type,
            email,
            recognitionId,
            searchTerm,
            giftStatus
          },
          pagination: {
            limit,
            page
          }
        })
      );
    },
    options
  );
};
